import Vue from 'vue'
import Vuex from 'vuex'

import htmlClass from "./htmlclass.module";
import sale from "./sale.module";

Vue.use(Vuex)

export default new Vuex.Store({
  namespace: true,
  modules: {
    htmlClass,
    sale
  }
})

//export default store;



// WEBPACK FOOTER //
// ./src/store/index.js